module.exports = __webpack_public_path__ + "static/media/check-green.762d89ea.svg";